
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __appWithI18n from 'next-translate/appWithI18n'
// @ts-ignore
    
import '../styles/globals.css';

import type { AppProps } from 'next/app';
import { FirebaseOptions } from '@firebase/app-types';
import React from 'react';
import { RecoilRoot } from 'recoil';
import { ToastProvider } from 'react-toast-notifications';
import { TopcoCenterToast } from '@src/view/common/toast';
import { TopcoScript } from '@src/view/common/script';
import firebaseConfig from '@src/auth/appConfig';
import { initializeApp } from '@firebase/app';
import dynamic from 'next/dynamic';
import SeoComponent from '@src/view/common/seo/SeoCompnent';
import { GoogleTagManager } from '@next/third-parties/google';
import Loading from '@src/view/error/TopcoLoading';
import { ThemeProvider } from 'next-themes';

const options: FirebaseOptions = firebaseConfig.env.firebaseAuth;
initializeApp(options);

const TheLayout = dynamic<any>(
  () => import('@src/view/theLayout').then((mod: any) => mod.TheLayout),
  { ssr: true, suspense: true, loading: () => <Loading.LottieLoading /> },
);

function MyApp({ Component, pageProps }: AppProps) {
  return (
    <>
      <TopcoScript />
      {process.env.REACT_APP_ENVIRONMENT === 'production' && (
        <GoogleTagManager gtmId="GTM-PZC3LF2P" />
      )}

      <ToastProvider
        autoDismiss
        autoDismissTimeout={2 * 1000}
        components={{ Toast: TopcoCenterToast }}
      >
        <RecoilRoot>
          <ThemeProvider
            enableSystem={false} // prefers-color-scheme 사용여부
            attribute="class"
          >
            <SeoComponent.Default />
            <TheLayout>
              <Component {...pageProps} />
            </TheLayout>
          </ThemeProvider>
        </RecoilRoot>
      </ToastProvider>
    </>
  );
}

const __Page_Next_Translate__ = MyApp;


// @ts-ignore
    export default __appWithI18n(__Page_Next_Translate__, {
// @ts-ignore
      ...__i18nConfig,
// @ts-ignore
      isLoader: true,
// @ts-ignore
      skipInitialProps: true,
// @ts-ignore
      loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
    });
// @ts-ignore
  